import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { RotatingIcon, StyledChip } from '../components';
import { SortAttribute, SortOrder } from '../../../../../../hooks/useBuildingFilter/context';
import useBuildingFilter from '../../../../../../hooks/useBuildingFilter';

interface Props {
  sortAttribute: SortAttribute;
}

export const SortChip: FC<Props> = ({ sortAttribute }) => {
  const { t } = useTranslation();
  const {
    updateOrder,
    order: [sort, dir]
  } = useBuildingFilter();
  const isAscending = dir === SortOrder.ASC;

  const label = t('orderBy', {
    attribute: t(sortAttribute).toLowerCase(),
    direction: t(`dir.${sort === sortAttribute && isAscending ? SortOrder.DESC : SortOrder.ASC}`).toLowerCase()
  });

  return (
    <StyledChip
      aria-label={label}
      variant={sort === sortAttribute ? 'primary' : 'secondary'}
      onClick={() => updateOrder(sortAttribute)}
      label={
        <Fragment>
          {t(sortAttribute)}
          <RotatingIcon turn={sort === sortAttribute && isAscending} name="arrow_up" />
        </Fragment>
      }
    />
  );
};
